import MasterOrganizeSettingPage from './MasterOrganizeSettingPage';

export default MasterOrganizeSettingPage;
